export type CrossFilter = {
  field: string;
  value: string;
  sourceWidgetId?: string;
  label?: string;
};

export type ChartInteraction = {
  widgetId: string;
  field: string;
  value: string;
  label?: string;
};

export function crossFilterKey(filter: CrossFilter): string {
  return `${filter.field}::${filter.value}`;
}

export function toggleCrossFilter(
  filters: CrossFilter[],
  next: CrossFilter
): CrossFilter[] {
  const key = crossFilterKey(next);
  const exists = filters.find((f) => crossFilterKey(f) === key);
  if (exists) {
    return filters.filter((f) => crossFilterKey(f) !== key);
  }
  const withoutField = filters.filter((f) => f.field !== next.field);
  return [...withoutField, next];
}
